import styles from './Offer.module.scss';
import Typography from '@mui/material/Typography';
import {Button} from '../../../common/Button/Button';
import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

type BuyPropsType = {
    header: string
    price: string
    sale?: string
    discount?: string
    additions?: {
        id: number
        value: string
    }[]
    bullets: {
        id: number
        value: string
    }[]
    link: string
}

export const Offer: React.FC<BuyPropsType> = (
    {header, price, sale, discount, bullets, additions, link}
) => {
    const [open, setOpen] = useState(false);

    const handleOpen = (e: React.MouseEvent) => {
        e.preventDefault();
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div className={styles.innerContainer}>
            <Typography variant={'h1'}
                        className={styles.title}>{header.toUpperCase()}</Typography>
            <Typography variant={'h2'}
                        className={sale ? styles.priceWithLane : styles.price}>{price}</Typography>

            <Typography variant={'h2'}
                        className={styles.sale}>{sale}

                <div className={styles.saleDiscount}>{discount}</div>

            </Typography>


            <div className={styles.bulletBlock}>
                {bullets.map(bullet => (
                        <Typography key={bullet.id} variant={'h3'}
                                    className={styles.bullet}>{bullet.value}</Typography>
                    )
                )
                }
            </div>

            {additions &&
                <div className={styles.additions}>
                    {additions.map(addition => (
                            <Typography key={addition.id} variant={'h3'}
                                        className={styles.addition}>{addition.value}</Typography>
                        )
                    )
                    }
                </div>
            }

            <div onClick={handleOpen}>
                <Button className={styles.button}>
                    Купить курс
                </Button>
            </div>

            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Сайт переехал</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Наш сайт переехал на другой домен. Теперь вы можете приобрести курсы на нашем новом сайте:{' '}
                        <a href="https://academy.arsnails.ru" target="_blank" rel="noopener noreferrer" style={{ color: '#053543', fontWeight: 'bold' }}>
                            academy.arsnails.ru
                        </a>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">Закрыть</Button>
                </DialogActions>
            </Dialog>

            {/*<div className={styles.bulletBlock}>
                    {introductionValues.buy.zaglushka.map(bullet => (
                            // <Zoom cascade key={bullet.id}>
                            <Typography key={bullet.id} variant={'h3'}
                                        className={styles.bullet}>{bullet.value}</Typography>
                            // </Zoom>
                        )
                    )
                    }
                </div>*/}

        </div>
    )
}